import { create } from 'zustand';
import { ProductConditionType, ProductLine } from 'types';

interface ProductState {
  currentProduct: ProductLine | null;
  setCurrentProduct: (product: ProductLine | null) => void;
  isProductNew: boolean | null;
  setProductNew: (isNew: boolean | null) => void;
  productCondition: ProductConditionType | null;
  setProductCondition: (condition: ProductConditionType | null) => void;
  productId: string;
  setProductId: (id: string) => void;
  reset: () => void;
}

export const useProductStore = create<ProductState>((set) => ({
  currentProduct: null,
  setCurrentProduct: (product: ProductLine | null) => set({ currentProduct: product }),
  isProductNew: null,
  productCondition: null,
  setProductCondition: (condition: ProductConditionType | null) =>
    set({ productCondition: condition }),
  setProductNew: (isNew: boolean | null) => set({ isProductNew: isNew }),
  productId: '',
  setProductId: (id: string) => set({ productId: id }),
  reset: () =>
    set({
      currentProduct: null,
      isProductNew: null,
      productCondition: null,
    }),
}));
